import axiosAuth from "@/services/axiosAuth";
import { ATTACHMENT_API } from "@/services/attachment/apiRoutes";
import { ONBOARDING_API } from "../apiRoutes";

/** The file exactly as it was uploaded. */
export const downloadBulkUploadFile = async (attachmentId: string | number) =>
  await axiosAuth.get(`${ATTACHMENT_API}/${attachmentId}/download`, { responseType: "blob" });

/** Rows that failed validation, as CSV (built from the stored file, so it works for validated-only uploads too). */
export const downloadBulkUploadErrorLog = async (communityId: string, attachmentId: string | number) =>
  await axiosAuth.get(`${ONBOARDING_API(communityId)}/occupancy/${attachmentId}/error-log`, { responseType: "blob" });
